import { invalidStatuses } from '../constants/invalidStatuses';
import {
  EventStatus,
  VisitorPassQueryResponse,
  SubmissionDetails,
  SubmissionStatus,
} from '../types';

export function deriveSubmissionDetails(
  items: VisitorPassQueryResponse[] | undefined
): SubmissionDetails {
  if (!items?.length) {
    return { status: SubmissionStatus.Invalid, isCancellable: false };
  }

  const allTerminal = items.every(pass =>
    invalidStatuses.includes(pass.status as EventStatus)
  );

  return {
    status: allTerminal ? SubmissionStatus.Cancelled : SubmissionStatus.Invalid,
    isCancellable: !allTerminal,
  };
}
